<template>
  <div class="match-back-home-button" @click="goHome">
    <img :src="image" :alt="alt" />
  </div>
</template>

<script>
import { getImg } from '@/utils/matchAsset'

export default {
  name: 'MatchBackHomeButton',
  props: {
    image: {
      type: String,
      default: () => getImg('match/pc/match/back-home-button.png'),
    },
    alt: {
      type: String,
      default: '返回首页',
    },
  },
  methods: {
    goHome() {
      this.$router.push('/match')
    },
  },
}
</script>

<style scoped lang="scss">
.match-back-home-button {
  position: fixed;
  top: 0.296875rem;
  right: 0.1875rem;
  right: max(0.1875rem, calc((100vw - 1920px) / 2 + 0.1875rem));
  z-index: 11;
  width: 1.302083rem;
  height: 0.432292rem;
  cursor: pointer;
    img {
    display: block;
    width: 100%;
    height: auto;
  }
}

@media (max-width: 750px) {

  .match-back-home-button {
    top: 7vw;
    right: 4vw;
    width: 26vw;
    height: auto;
  }
}

</style>
